define('core/utils/cookies',[
], function (
) {
    'use strict';

    var exports = {
        _doc: window.document,

        create: function (name, value, options) {
            if (!options)
                options = {};

            var cookie = name + '=' + value + '; path=' + (options.path || '/');
            var domain = options.domain;
            var expiresIn = options.expiresIn;

            if (domain)
                cookie += '; domain=.' + domain;

            if (Object.prototype.toString.call(expiresIn) === '[object Number]') {
                // expiresIn is in ms
                var date = new Date(new Date().getTime() + expiresIn);
                cookie += '; expires=' + date.toGMTString();
            }

            if (exports._doc.location.protocol === 'https:')
                cookie += '; secure';

            // For Chrome starting with version 80, we must add this flag to our
            // cookies so that they work undisrupted in a third-party cookie
            // context, otherwise cookies that don't specify a flag will
            // be treated as `SameSite=Lax` which prevents our cookies from
            // being set in a cross-site (third-party) context.
            //
            // See https://blog.chromium.org/2019/10/developers-get-ready-for-new.html
            cookie += '; SameSite=None';

            exports._doc.cookie = cookie;
        },

        read: function (name) {
            var nameEQ = name + '=';
            var cookies = exports._doc.cookie.split(';');
            var cookie;

            for (var i = 0; i < cookies.length; i++) {
                cookie = cookies[i].replace(/^\s+/, '');

                if (cookie.indexOf(nameEQ) === 0)
                    return cookie.substring(nameEQ.length);
            }

            return null;
        },

        erase: function (name, options) {
            var cookie = {};
            for (var key in options) {
                if (options.hasOwnProperty(key))
                    cookie[key] = options[key];
            }

            cookie.expiresIn = -1;
            return exports.create(name, '', cookie);
        },


        supported: function () {
            exports.create('cookie_support', '1');
            if (exports.read('cookie_support') === '1') {
                exports.erase('cookie_support');
                return true;
            }
            return false;
        },
    };

    return exports;
});

